import { render } from "./TheGlobalNav.vue?vue&type=template&id=85fa313e&scoped=true&ts=true"
import script from "./TheGlobalNav.vue?vue&type=script&lang=ts"
export * from "./TheGlobalNav.vue?vue&type=script&lang=ts"

import "./TheGlobalNav.vue?vue&type=style&index=0&id=85fa313e&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src866133389/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-85fa313e"]])

export default __exports__